var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClothing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 50,
    r: 50,
    fill: "#8F39FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74 78.6825C74 78.6825 72.2117 80.0716 69.0326 80.4189C66.1516 80.6793 63.7672 80.2453 61.979 79.8112C59.1972 73.7339 54.1305 62.8816 53.3357 60.3639C53.4351 60.9716 56.1175 77.3803 58.5018 83.3707C58.0051 83.8916 57.2103 84.0653 56.1175 83.9784C51.7462 83.3707 48.0703 80.4189 46.0834 82.1553C44.3945 83.6312 39.7251 83.2839 38.6323 82.6762C40.5199 75.3834 42.3082 64.7916 42.4075 64.2707C41.7121 66.528 37.6388 75.3834 34.7578 81.5475C31.2806 81.808 27.9028 80.3321 28.0021 79.6375C39.0297 61.1452 40.818 50.9875 40.4206 44.9102C40.0232 39.7011 42.7056 33.7975 43.1029 31.3666C43.401 28.9357 41.6127 25.4629 41.6127 25.4629C40.5199 20.7748 50.256 21.2089 53.7331 18.8648C54.2299 17.5625 55.2233 15.9998 55.2233 15.9998L56.1175 16.2602C54.5279 20.167 57.2103 21.6429 56.5149 24.2475C56.0181 26.4179 54.2299 27.5466 54.7266 31.627C55.124 34.9261 58.0051 38.1384 58.1044 43.087C58.2038 46.5598 56.5149 49.5116 58.6011 55.1548C61.3829 62.708 67.3437 73.2998 74 78.6825Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClothing);
export default __webpack_public_path__ + "static/media/clothing.11d5d27a5429fb06c20a492261b4831c.svg";
export { ForwardRef as ReactComponent };